// src/services/adminStaffPermissions.api.js
import { adminApiRequest } from "./adminApi";

export const getStaffPermissions = (userId) =>
  adminApiRequest(`/admin/staff-permissions/${userId}`);

export const updateStaffPermissions = (userId, data) =>
  adminApiRequest(`/admin/staff-permissions/${userId}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
